import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=6a363990"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports